import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from "react";
import { Box, useHoverable, useFocusable, usePressable, } from "@gemini/core";
import { TabStyles } from "./TabStyles";
export const Tab = ({ label, name, Icon, isActive, onPress }) => {
    const ref = useRef(null);
    const { boxProps: hoverProps, isHovered } = useHoverable();
    const { boxProps: focusProps, isFocused } = useFocusable(ref);
    const { boxProps: pressProps, isPressed } = usePressable({ onPress });
    const backgroundStyles = {
        backgroundColor: "#292D3B",
        ...TabStyles({
            isHovered,
            isPressed,
            isFocused,
            isActive,
        }),
    };
    return (_jsxs(Box, { as: "button", id: `tab-${name}`, ref: ref, role: "tab", display: "flex", alignItems: "center", flexWrap: "nowrap", paddingVertical: "spacing.8", paddingHorizontal: "spacing.16", cursor: "pointer", height: "sizing.40", borderWidth: "borderWidth.none", onClick: onPress, "aria-selected": isActive, ...pressProps, ...hoverProps, ...focusProps, ...backgroundStyles, children: [_jsx(Icon, {}), _jsx(Box, { as: "span", marginLeft: "spacing.6", whiteSpace: "nowrap", children: label })] }));
};
